import { Space } from '@gr-monorepo/common/ui';
import { GratitudesApi } from 'api';
import { LogPageEventProps } from 'features/shared/ClickStream';
import FileSaver from 'file-saver';
import React, { useRef } from 'react';
import { Card, Cover, ItemsWrap, RowWrap, Text, Title } from './styled';
import { Gratitude } from './useGratitudes';

export const Item = (props: { data: Gratitude; logPageEvent: (e: LogPageEventProps) => void }) => {
  const dowmloadRef = useRef(false);
  const downloadPdf = async (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    if (dowmloadRef.current) return;
    dowmloadRef.current = true;

    props.logPageEvent({
      eventType: 'gratitude_download',
      eventInfo: `Благодарности: Скачивание благодарности`,
    });
    try {
      let blob: string | Blob = '';
      blob = await GratitudesApi.downloadGratitude(props.data.id);
      if (blob) {
        FileSaver.saveAs(blob, `${props.data.title}.pdf`);
      }
    } catch (e) {
      alert('Ошибка скачивания документа');
    }
    dowmloadRef.current = false;
  };
  return (
    <Card onClick={downloadPdf} isNew={props.data.isNew} data-qa-id="reward_preview">
      <Cover style={{ backgroundImage: `url('${props.data.cover}')` }} />
      <Space axis="vertical" size={12} />
      <Text>{props.data.title}</Text>
    </Card>
  );
};

const ItemsRow = (props: { title: string; cards: Gratitude[]; logPageEvent: (e: LogPageEventProps) => void }) => {
  return (
    <RowWrap>
      <Title>{props.title}</Title>
      <Space axis="vertical" size={16} />

      <ItemsWrap>
        {props.cards.map((el) => (
          <Item key={el.id} data={el} logPageEvent={props.logPageEvent} />
        ))}
      </ItemsWrap>
    </RowWrap>
  );
};

export default ItemsRow;
